function normalizeRedirectUrl(rawUrl) {
    if (!rawUrl) {
        return null;
    }

    if (typeof window === 'undefined' || !window.location?.origin) {
        if (rawUrl.startsWith('/')) {
            return rawUrl;
        }

        return rawUrl;
    }

    try {
        const parsedUrl = new URL(rawUrl, window.location.origin);

        if (parsedUrl.origin === window.location.origin) {
            return `${parsedUrl.pathname}${parsedUrl.search}${parsedUrl.hash}`;
        }

        return parsedUrl.toString();
    } catch (e) {
        return rawUrl;
    }
}

function inferRedirectFromResponse(response, payload) {
    if (payload?.redirectUrl) {
        return payload.redirectUrl;
    }

    if (!response) {
        return null;
    }

    if (response.redirected && response.url) {
        return normalizeRedirectUrl(response.url);
    }

    const contentType = response.headers?.get?.('content-type') || '';
    if (response.ok && !contentType.includes('application/json') && response.url) {
        return normalizeRedirectUrl(response.url);
    }

    return null;
}

export function parseRouteResponse(response, payload) {
    const inferredRedirectUrl = inferRedirectFromResponse(response, payload);

    if (response?.status === 404 || payload?.state === 'not_found') {
        return {kind: 'not_found', redirectUrl: null};
    }

    if (response?.status === 401 || payload?.state === 'unauthorized') {
        return {kind: 'unauthorized', redirectUrl: inferredRedirectUrl};
    }

    if (payload?.state === 'redirect') {
        return {kind: 'redirect', redirectUrl: inferredRedirectUrl};
    }

    if (inferredRedirectUrl) {
        return {kind: 'redirect', redirectUrl: inferredRedirectUrl};
    }

    if (response?.ok) {
        return {kind: 'ok', redirectUrl: null};
    }

    return {kind: 'error', redirectUrl: payload?.redirectUrl || null};
}
